<div
  class="create-form-container"
  fxLayout="column"
  fxLayoutAlign="start stretch"
>
  <div fxLayout="row" fxLayoutAlign="start center">
    <p>{{ data.text.CreatePack }}</p>
  </div>
  <div class="form-field-container" fxLayout="column">
    <mat-form-field class="text-input">
      <input
        matInput
        type="text"
        placeholder="{{ data.text.AddPackTitle }}"
        [formControl]="packName"
      />
      <div matSuffix fxLayout="row" fxLayoutAlign="end center">
        <mat-spinner
          matSuffix
          *ngIf="checkingPackName$ | async"
          [diameter]="14"
        >
        </mat-spinner>
        <button
          mat-button
          mat-icon-button
          aria-label="Clear"
          (click)="clearForm()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-form-field>
    <div class="errors">
      <mat-error *ngIf="packName.hasError('required') && packName.dirty">{{
        data.text.PackRequired
      }}</mat-error>
      <mat-error
        *ngIf="
          (packName.hasError('minlength') || packName.hasError('maxlength')) &&
          !packName.hasError('required') &&
          packName.dirty
        "
        >{{ data.text.PackLength }}</mat-error
      >
      <mat-error *ngIf="packName.hasError('nameExists') && packName.dirty">{{
        data.text.PackExists
      }}</mat-error>
    </div>
  </div>
  <div fxFlex="grow" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      mat-raised-button
      class="portal-btn btn-primary"
      (click)="cancelNameChange()"
    >
      {{ data.text.Cancel }}
    </button>
    <div class="status">
      <div
        *ngIf="savingPack$ | async"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
      >
        <mat-spinner [diameter]="36"></mat-spinner>
        <div class="status-text">
          {{ data.text.CreatingPack }}
        </div>
      </div>
      <div
        *ngIf="savedPack$ | async"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
      >
        <mat-icon class="success">check_circle</mat-icon>
        <div class="status-text">
          {{ data.text.CreatedPack }}
        </div>
      </div>
      <div
        *ngIf="errorEncountered$ | async"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
      >
        <mat-icon class="error">highlight_off</mat-icon>
        <div class="status-text">
          {{ data.text.ErrorCreatingPack }}
        </div>
      </div>
    </div>
    <button
      mat-raised-button
      class="portal-btn btn-bright"
      [disabled]="
        packName.status === status.INVALID || packName.status === status.PENDING
      "
      (click)="createNewPack()"
    >
      {{ data.text.Create }}
    </button>
  </div>
</div>
